import TrackerHistory from '@/applications/scrum/components/TrackerHistory/TrackerHistory'
export default {
  name: 'TrackerHistory',
  mixins: [TrackerHistory],
  data () {
    return {
      panels: []
    }
  },
  async mounted () {
    await this.fetchHistory()
    this.openAllPanels()
  },
  methods: {
    openAllPanels () {
      this.panels = this.historyArray.map((_, index) => index)
    }
  }
}
